import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import LogoutConfimation from "./LogoutConfimation";
import { toast } from "react-toastify";
import { logOut, useUser } from "../redux/services/authSlice";
import { useDispatch } from "react-redux";
import logo from "../assests/BEFLogo.png";
import { IoIosArrowDown } from "react-icons/io";

const DropdownUser = ({getsingleClassesData}) => {
  const location = useLocation();
  const { pathname } = location;
  const { user } = useUser();
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef();
  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);
  const handleToggle = () => setConfirm((prevState) => !prevState);

  const handleLogout = () => {
    setTimeout(() => {
      navigate("/login");
      setConfirm(!confirm);
      dispatch(logOut());
    }, 1000);
  };

  const confirmLogout = () => {
    handleLogout();
    toast("Logout successfully", {
      autoClose: 2000,
      pauseOnHover: false,
    });
  };

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        dropdownOpen &&
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("click", checkIfClickedOutside);
    return () => {
      document.removeEventListener("click", checkIfClickedOutside);
    };
  }, [dropdownOpen]);

  return (
    <>
      <div className="relative">
        <div
          onClick={(e) => {
            e.stopPropagation();
            setDropdownOpen((prevState) => !prevState);
          }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <span className="h-12 w-12 rounded-full flex justify-center items-center">
            <img
              src={logo}
              alt={user.name}
              className="w-full h-full rounded-full object-cover"
            />
          </span>
          <div className="hidden sm:block text-left cursor-pointer ">
            <span className="block text-sm font-medium text-black">
              {user?.ownerName || getsingleClassesData?.ownerName || "Welcome user"}
            </span>
            <span className="block text-xs">{user.name || getsingleClassesData?.name}</span>
          </div>
          <IoIosArrowDown />
        </div>
        {dropdownOpen && (
          <div
            ref={menuRef}
            className="absolute right-0 sm:right-0 top-14 w-56 border border-[#d5d3d3] rounded-md bg-white p-2 shadow-lg"
          >
            <ul className="flex flex-col space-y-2 font-medium capitalize">
              <li onClick={toggleDropdown}>
                <NavLink to="/profile-update">
                  <button
                    type="button"
                    className={`${
                      pathname === "/profile-update"
                        ? "bg-[#124699] text-white hover:text-white hover:!bg-[#124699]"
                        : "text-gray-700 hover:bg-[#e8effa] hover:text-gray-900"
                    } py-2 px-4 w-full rounded-md`}
                  >
                    Profile Update
                  </button>
                </NavLink>
              </li>
              <li onClick={toggleDropdown}>
                <NavLink to="/change-password">
                  <button
                    type="button"
                    className={`${
                      pathname === "/change-password"
                        ? "text-white bg-[#124699]"
                        : "text-black"
                    } py-2 px-4 w-full rounded-md`}
                  >
                    Change Password
                  </button>
                </NavLink>
              </li>
              <li onClick={handleToggle}>
                <button
                  type="button"
                  className="py-2 px-4 w-full hover:bg-[#e8effa] rounded-md"
                >
                  Log Out
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>

      {confirm && (
        <LogoutConfimation
          confirm={confirm}
          onLogout={confirmLogout}
          onCancel={() => setConfirm(!confirm)}
        />
      )}
    </>
  );
};

export default DropdownUser;
